/* eslint-disable react/button-has-type */
/* This example requires Tailwind CSS v2.0+ */
import { Button, useMantineTheme } from '@mantine/core'
import classNames from 'classnames'
import useTranslation from 'next-translate/useTranslation'
import { MdAdd } from 'react-icons/md'

const EmptyStates = ({
  description,
  onClick,
}: {
  description: string
  onClick: () => void
}) => {
  const { colorScheme } = useMantineTheme()
  const isDark = colorScheme === 'dark'
  const { t } = useTranslation('common')
  return (
    <button
      className={classNames(
        'border rounded-lg p-3 my-3 border-opacity-20 border-dashed w-full',
        isDark ? 'border-gray-200' : 'border-gray-900',
      )}
      onClick={() => onClick()}
    >
      <div className="text-center">
        <svg
          className="mx-auto h-12 w-12 text-gray-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            vectorEffect="non-scaling-stroke"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
          />
        </svg>
        <p className="mt-1 text-sm text-gray-500">{description}</p>
        <div className="mt-6">
          <Button leftIcon={<MdAdd size={14} />}>{t('add')}</Button>
        </div>
      </div>
    </button>
  )
}

export default EmptyStates
